import { render, staticRenderFns } from "./TabUnites.vue?vue&type=template&id=6e56369c&"
import script from "./TabUnites.vue?vue&type=script&lang=js&"
export * from "./TabUnites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports